<template>
    <!--内容区域-->
    <div class="con-body">
        <div class="content-area">
            <div v-if="lists.length > 0">
                <div class="con-cate" v-for="(list,index) in lists" v-bind:key="index">
                    <div class="con-top">
                        <div class="con-title">{{list.text}}</div>
                        <div class="con-more" @click="go.goMore(list.type,list.text)">{{$t("more")}}</div>
                    </div>
                    <div class="con-con" >
                        <div class="con-item" v-for="(item,index2) in list.list" v-bind:key="index2">
                            <img @click="go.goDetail(item.id)" :src="item.img">
                            <div @click="go.goDetail(item.id)" class="con-name">{{item.title}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "homepage",
  components: {
    pagebottom
  },
  data() {
    return {
      lists: [],
    };
  },
  mounted: function() {
    //首页统一检测是否有回跳，有的话，优先回跳,主要用于充值回来的检查
    // var url = JSON.parse(localStorage.getItem("loginBack"));
    // if(url){
    //     localStorage.removeItem("loginBack");
    //     this.$router.push(url);
    // }else{
    this.getLists();
    // }
  },
  methods: {
    //获取首页列表
    getLists() {
      this.$indicator.open({
        text: "Loading...",
        spinnerType: "fading-circle"
      });
      this.req.indexLists().then(res => {
        this.$indicator.close();
        this.lists.push(res.data.main_list);
        this.lists.push(res.data.best_list);
        this.lists.push(res.data.hots_list);
        this.lists.push(res.data.like_list);
      });
    }
  }
};
</script>

<style scoped>
    .con-body{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: #f2f2f2;
    }
    /*内容分类区域*/
    .content-area{
        width: 100%;
        height: auto;
    }
    .con-cate{
        width:100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.4rem 0 0 0.4rem;
        background: #ffffff;
        margin-top: 0.16rem;
    }
    .con-cate:last-child{
        padding-bottom: 0.18rem;
    }
    .con-top{
        width: 100%;
        box-sizing: border-box;
        padding:0 0.4rem 0.18rem 0;
        display: flex;
        justify-content: space-between;
    }
    .con-title,.con-more{
        color: #ff1f4f;
    }
    .con-title{
        font-size: 0.3rem;
        line-height: 0.3rem;
    }
    .con-more{
        font-size: 0.2rem;
        line-height: 0.2rem;
        padding-top: 0.1rem;
    }
    .con-con{
        overflow: hidden;
    }
    .con-item{
        width: 1.82rem;
        height: auto;
        float: left;
        margin-right: 0.62rem;
        padding-top: 0.1rem;
    }
    .con-item:nth-child(3n){
        margin-right: 0;
    }
    .con-item img{
        display: block;
        width: 1.82rem;
        height: 2.56rem;
    }
    .con-name{
        width: 1.82rem;
        height: 0.4rem;
        font-size: 0.26rem;
        margin: 0.24rem 0 0.4rem;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/homepage.vue